module.exports = __webpack_public_path__ + "static/media/Paus hörnsoffa 2 rekliner micro grå bistro miljö modell 3 2023.99366fae.jpg";